import { TrackerEvent } from './tracker-event';
import { createTrackReplayer, convertMonetaryValueToNumber } from './util';
import { loadScript } from '@fastcampus/browser-util';

export class MobonTracker {
  static create(opts, context) {
    return new MobonTracker(opts, context);
  }

  constructor({ id, userId }, context) {
    this.id = id;
    this.userId = userId;
    this.name = 'mobon';

    loadScript('https://cdn.megadata.co.kr/js/en_script/3.6/enliple_min3.6.js')
      .then(() => {
        const mobRf = new context.EN();
        mobRf.setData('userid', this.id);
        mobRf.setSSL(true);
        mobRf.sendRf();
        this.EN = context.EN;

        // 스크립트 로딩 후에 이벤트를 보내야 함!
        this.ready = true;
      })
      .catch((err) => console.error('install err!', err));
  }

  getPayloadForCourseView(data) {
    const defaultProduct = data.products && data.products.sort((a, b) => Number(b.id) - Number(a.id))[0];
    const productsString = data.products && data.products.map((product) => String(product.id)).join(',');
    const formatCategoryId = String(data.formatId || '') + '/' + String(data.categoryId || '');
    const imageUrl =
      data.imageAssetUrl ||
      'https://storage.googleapis.com/static.fastcampus.co.kr/prod/assets/img/common/share-fastcampus.jpg';

    const payload = {
      sc: '5d97cc3741d97b36a35aa75368e208d6',
      pcode: String(data.id),
      pnm: encodeURIComponent(encodeURIComponent(data.publicTitle)),
      img: encodeURIComponent(imageUrl),
      cate1: encodeURIComponent(encodeURIComponent(formatCategoryId)),
      price: String(convertMonetaryValueToNumber(defaultProduct && defaultProduct.listPrice)),
      dcPrice: String(convertMonetaryValueToNumber(defaultProduct && defaultProduct.salePrice)),
      soldOut: '2', //옵션 1:품절,2:품절아님
      mdPcode: productsString,
    };

    return payload;
  }

  getPayloadForTransactionPayment(data) {
    const transactionId =
      data.transactionInfo && data.transactionInfo.transaction && data.transactionInfo.transaction.id;
    const title = data.productSaleInfo && data.productSaleInfo.product && data.productSaleInfo.product.title;
    const amount = data.transactionInfo && data.transactionInfo.transaction && data.transactionInfo.transaction.amount;
    const quantity =
      (data.transactionInfo && data.transactionInfo.transaction && data.transactionInfo.transaction.quantity) || 1;

    const payload = {
      ordcode: transactionId,
      qty: quantity,
      price: amount,
      pnm: encodeURIComponent(encodeURIComponent(title)),
    };

    return payload;
  }

  track(event, data) {
    if (!this.ready) {
      if (process.env['NODE_ENV'] !== 'prod') console.error('**ignore** not ready!', event, data);
      const trackReplayer = createTrackReplayer({ target: this, time: 3 });
      trackReplayer(event, data);
      return;
    }
    switch (event) {
      case TrackerEvent.PAGE_VIEW:
        break;
      case TrackerEvent.USER_SIGNUP:
        break;
      case TrackerEvent.USER_LOGIN:
        break;
      case TrackerEvent.FORMAT_VIEW:
        break;
      case TrackerEvent.CATEGORY_VIEW:
        break;
      case TrackerEvent.COURSE_VIEW: {
        const payload = this.getPayloadForCourseView(data);
        const sh = new this.EN();
        sh.setData('sc', payload.sc);
        sh.setData('userid', this.id);
        sh.setData('pcode', payload.pcode);
        sh.setData('pnm', payload.pnm);
        sh.setData('img', payload.img);
        sh.setData('cate1', payload.cate1);
        sh.setData('price', payload.price);
        sh.setData('dcPrice', payload.dcPrice);
        sh.setData('soldOut', payload.soldOut);
        sh.setData('mdPcode', payload.mdPcode);
        sh.setSSL(true);
        sh.sendRfShop();
        break;
      }
      case TrackerEvent.ENROLLMENT_VIEW:
        break;
      case TrackerEvent.ENROLLMENT_PENDING:
        break;
      case TrackerEvent.TRANSACTION_ORDER:
        break;
      case TrackerEvent.TRANSACTION_PAYMENT:
        if (data) {
          const payload = this.getPayloadForTransactionPayment(data);

          const cn = new this.EN();
          cn.setData('uid', this.id);
          cn.setData('ordcode', payload.ordcode);
          cn.setData('qty', payload.qty);
          cn.setData('price', payload.price);
          cn.setData('pnm', payload.pnm);
          cn.setSSL(true);
          cn.sendConv();
        }
        break;
      case TrackerEvent.COMMON: {
        break;
      }
    }
  }
}
